import { FlexColCenVer } from '@/UI/styles';
import { Scrubber } from '@/UI/VideoAudio/Scrubber/Scrubber';
import { MediaPlayerControlsRow } from './MediaPlayerControlsRow';
import type { SxProps, Theme } from '@/UI/theme.exports';
import type { CompactMediaPlayerControlsProps } from './types';

const playheadHeight = 10;

export function CompactMediaPlayerControls({
  currentTime,
  duration,
  fps,
  isPaused,
  isMuted,
  hasAudio,
  scrubberPosition = 'top',
  showFrameStepButtons = true,
  timeInputVariant = 'timecode',
  onTogglePlay,
  onSetTime,
  onToggleMute,
  sx,
}: CompactMediaPlayerControlsProps) {
  const scrubber = (
    <Scrubber
      duration={duration}
      setTime={onSetTime}
      time={currentTime}
      playheadHeight={playheadHeight} />
  );

  return (
    <FlexColCenVer sx={[{ gap: 1.5, py: 2, width: '100%' }, sx] as SxProps<Theme>}>
      {scrubberPosition === 'top' && scrubber}
      <MediaPlayerControlsRow
        currentTime={currentTime}
        duration={duration}
        fps={fps}
        isPaused={isPaused}
        isMuted={isMuted}
        hasAudio={hasAudio}
        showFrameStepButtons={showFrameStepButtons}
        timeInputVariant={timeInputVariant}
        onTogglePlay={onTogglePlay}
        onSetTime={onSetTime}
        onToggleMute={onToggleMute}
      />
      {scrubberPosition === 'bottom' && scrubber}
    </FlexColCenVer>
  );
}
